import { EnvironmentProviders, Provider } from '@angular/core';
import { FullIndexService } from '../../entities/full-index/service/full-index.service';
import { TravomateFullIndexService } from './full-index/service/travomate-full-index-service';

export const entitiesProviders: Provider[] | EnvironmentProviders[] = [
  {
    provide: FullIndexService,
    useClass: TravomateFullIndexService,
  },
];
